import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import classes from "../components/Management/Management.module.scss";
import HeroSection from "../components/HeroSection/HeroSection";
import PurchaseManagement from "../components/Management/PurchaseManagement";
import InspectionManagement from "../components/Management/InspectionManagement";
import UserManagement from "../components/Management/UserManagement";
import AnalyticsDashboard from "../components/Management/AnalyticsDashboard";
import DealerStockManagement from "../components/Management/DealerStockManagement";
import DealerAnalytics from "../components/Management/dealerAnalytics/DealerAnalytics";

const Management = () => {
    const [searchParams] = useSearchParams();
    // A link to a customer's page (?customer= / ?customerLead=, from the Users
    // tab or an email) or to a lead (?lead=, from Dealer Analytics) opens on
    // Dealer Stock, which opens it.
    const customerLink = searchParams.has("customer") || searchParams.has("customerLead") || searchParams.has("lead");
    const [activeTab, setActiveTab] = useState(customerLink ? 5 : 1);
    useEffect(() => {
        if (customerLink) setActiveTab(5);
    }, [customerLink]);
    return (
        <Layout>
            <HeroSection/>

            <section className={classes.userManagement}>
                <div className={classes.inner}>
                    <div className={classes.tabButtons}>
                        <button 
                            onClick={()=>setActiveTab(1)}
                            className={`${activeTab === 1 ? classes.active : classes.notActive } ${classes.button}`}>
                            Users Management
                        </button>
                        <button 
                            onClick={()=>setActiveTab(2)}
                            className={`${activeTab === 2 ? classes.active : classes.notActive } ${classes.button}`}>
                            Purchase Management
                        </button>
                        <button 
                            onClick={()=>setActiveTab(3)}
                            className={`${activeTab === 3 ? classes.active : classes.notActive } ${classes.button}`}>
                            Inspection Management
                        </button>
                        <button 
                            onClick={()=>setActiveTab(4)}
                            className={`${activeTab === 4 ? classes.active : classes.notActive } ${classes.button}`}>
                            Analytics
                        </button>
                        <button 
                            onClick={()=>setActiveTab(5)}
                            className={`${activeTab === 5 ? classes.active : classes.notActive } ${classes.button}`}>
                            Dealer Stock
                        </button>
                        <button
                            onClick={()=>setActiveTab(6)}
                            className={`${activeTab === 6 ? classes.active : classes.notActive } ${classes.button}`}>
                            Dealer Analytics
                        </button>
                    </div>
                    <hr/>
                    <div className={classes.tabContent}>
                        
                        { activeTab === 1 && <UserManagement/> }
                        { activeTab === 2 && <PurchaseManagement/>}
                        { activeTab === 3 && <InspectionManagement/>}
                        { activeTab === 4 && <AnalyticsDashboard/>}
                        { activeTab === 5 && <DealerStockManagement/>}
                        { activeTab === 6 && <DealerAnalytics/>}
                        
                    </div>
                </div>
            </section>

        </Layout>
  )
}

export default Management;